import React, { useEffect, useState, useCallback } from 'react';
// import { Row, Col, Upload, Button, message, Select, DatePicker } from "antd";
import LicenseForm from '../../form/subscription/LicenseForm';
import { getUser } from '../../api';
import useApplicationSession from '../../session/UserSession';

const License = () => {
    const [userdata, setUserdata] = useState(null);
    const token = useApplicationSession();
    const getUserInfo = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    const { license } = response.data;
                    setUserdata(license);
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        getUserInfo();
    }, [getUserInfo]);

    return (
        <div className="subscriptionContentContainer">
            <LicenseForm value={userdata} />
        </div>
    );
};

export default License;
